import DateSetting from "./KrDateSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrDateSetting = install(DateSetting); // 生成带有 install 方法的组件

export default KrDateSetting;
